import {IBaseEnvironment} from "./../../../environment/IBaseEnvironment";
import {IBaseEnvironmentProvider} from "./../../../environment/providers/IBaseEnvironmentProvider";
import {IEnvironmentGlobals} from "../../IEnvironmentGlobals";
import {IEnvironment} from "../environments/IEnvironment";
import {getLogger} from "@goodgamestudios/logger";
const logger = getLogger("EnvironmentProvider");

export class EnvironmentProvider implements IBaseEnvironmentProvider {
    public static ERROR_LOCKED: string = "The class is a singleton, please use EnvironmentProvider.instance instead.";
    public static ERROR_WRONG_ENVIRONMENT: string = "You have passed a no IEnvironment class.";
    public static ERROR_NO_ENVIRONMENT: string = "No suitable environment found. Cannot run the game without an environment.";
    public static ERROR_DUPLICATED_ENVIRONMENT: string = "You can't add a environment that is already registered.";

    protected static _locked: boolean = true;
    private static _instance: EnvironmentProvider;

    public static get instance(): EnvironmentProvider {
        if (!EnvironmentProvider._instance) {
            EnvironmentProvider._locked = false;
            EnvironmentProvider._instance = new EnvironmentProvider();
            EnvironmentProvider._locked = true;
        }

        return EnvironmentProvider._instance;
    }

    private _globals: IEnvironmentGlobals;
    private _available: IEnvironment[];
    private _current: IEnvironment;

    constructor() {
        if (EnvironmentProvider._locked) {
            throw new Error(EnvironmentProvider.ERROR_LOCKED);
        }

        this._available = [];
    }

    private getEnvironmentById(environmentId: string): IEnvironment {
        let detected: IEnvironment;
        for (let env of this._available) {
            if (env.id === environmentId) {
                detected = env;
                break;
            }
        }
        return detected;
    }

    public add(definition: any): void {
        let environment: IEnvironment;
        if (definition !== null && definition !== undefined) {
            environment = <IEnvironment>(new definition());
        }
        if (environment) {
            let env: IEnvironment = this.getEnvironmentById(environment.id);
            if (env === null || env === undefined) {
                environment.data.globals = this._globals;
                environment.initPatterns();
                this._available.push(environment);
            }
            else {
                throw new Error(EnvironmentProvider.ERROR_DUPLICATED_ENVIRONMENT);
            }
        }
        else {
            throw new Error(EnvironmentProvider.ERROR_WRONG_ENVIRONMENT);
        }
    }

    public detect(): IBaseEnvironment {
        let detected: IEnvironment;

        for (let env of this._available) {
            if (env.detection.isSupported()) {
                detected = env;
                break;
            }
        }

        if (!detected) {
            throw Error(EnvironmentProvider.ERROR_NO_ENVIRONMENT);
        }

        this._current = detected;
        logger.debug("Environemntdetected: " + detected.id);
        return this._current;
    }

    public setCurrentById(environmentId: string): IBaseEnvironment {
        let detected: IEnvironment = this.getEnvironmentById(environmentId);

        if (!detected) {
            throw Error(EnvironmentProvider.ERROR_NO_ENVIRONMENT);
        }

        logger.debug("setCurrentById", environmentId, detected);
        this._current = detected;

        return this._current;
    }

    public clear(): void {
        this._available = [];
        this._current = null;
    }

    public get current(): IEnvironment {
        return this._current;
    }

    public get globals(): IEnvironmentGlobals {
        return this._globals;
    }

    public set globals(value: IEnvironmentGlobals) {
        this._globals = value;
        for (let environment of this._available) {
            environment.data.globals = this._globals;
            environment.initPatterns();
        }
    }
}
